query CorporateChartOfAccounts {
  corporateChartOfAccounts(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
}
